import axios from "axios";
import { useState, useEffect } from "react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const useTeacherTotalCourses = (type,teacherId) => {
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (!teacherId) return;

   const fetchTotal = async () => {
  try {
    const response = await axios.get(
      `${BASE_URL}/teacher/${teacherId}/total-courses/`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
        params: {
          filter_key: type, 
        },
      }
    );

    setTotal(response.data.total);
  } catch (error) {
    console.error("Error fetching total courses:", error);
    setTotal(0); // fallback value
  }
};

    fetchTotal();
  }, [teacherId]);

  return total;
};
